import request from "@/utils/request.js"

// 服务提供商列表（跨租户）
export const listServiceProviderIgnoreTenant = (pageData, formData) => {
    return request.get(`/service-provider/ignoreTenant/page/${pageData.page}/${pageData.pageSize}`, {params: formData})
}

// 服务提供商-新增（跨租户）
export const addServiceProviderIgnoreTenant = (formData) => {
    return request.post('/service-provider/ignoreTenant', formData)
}

// 根据ID获取服务提供商详情（跨租户）
export const getServiceProviderIgnoreTenant = (providerId) => {
    return request.get(`/service-provider/ignoreTenant/${providerId}`)
}

// 服务提供商-修改（跨租户）
export const editServiceProviderIgnoreTenant = (updateData) => {
    return request.put('/service-provider/ignoreTenant', updateData)
}
